const useAuth = () => {   
  const user = JSON.parse(localStorage.getItem('user'));

  const accessToken = localStorage.getItem('access_token');
 
  if (user && user.access_token) {
    return true;  
  }

  if(accessToken) {
    return true;
  }
  
  return false;
};

export default useAuth;
